import { IconNames } from '@shipengine/giger-theme';
import { SpinnerMessagePosition, SpinnerSize, getStyles, getIconWrapperStyles, getIconStyles, getCustomSpinnerStyles, getMessageStyles } from './SpinnerStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { Icon } from '../Icon/Icon.js';

const Spinner = _ref => {
  let {
    loading = true,
    message,
    messagePosition = SpinnerMessagePosition.BOTTOM,
    size = SpinnerSize.SIZE_SMALL,
    color,
    image,
    ...otherProps
  } = _ref;
  if (!loading) {
    return null;
  }
  return jsxs("div", {
    css: getStyles(messagePosition),
    ...otherProps,
    children: [jsxs("div", {
      css: getIconWrapperStyles({
        messagePosition,
        color
      }),
      style: {
        color
      },
      children: [!image && jsx(Icon, {
        css: getIconStyles(size),
        name: IconNames.SPINNER
      }), image && jsx("span", {
        css: getCustomSpinnerStyles(size),
        children: image
      })]
    }), message && jsx("span", {
      css: getMessageStyles(messagePosition),
      children: message
    })]
  });
};

export { Spinner };
//# sourceMappingURL=Spinner.js.map
